import { PreferenceCategory } from '../../types';

export const CONSENT_DISPLAYED_TEXT_ITEMS = [
	PreferenceCategory.Analytics,
	PreferenceCategory.Functional,
	PreferenceCategory.Marketing,
	PreferenceCategory.StrictlyNecessary,
	PreferenceCategory.Unknown,
];
